import { render, staticRenderFns } from "./DormBedManagerDialog.vue?vue&type=template&id=3490d850&scoped=true"
import script from "./DormBedManagerDialog.vue?vue&type=script&lang=js"
export * from "./DormBedManagerDialog.vue?vue&type=script&lang=js"
import style0 from "./DormBedManagerDialog.vue?vue&type=style&index=0&id=3490d850&prod&scoped=true&lang=css"
import style1 from "./DormBedManagerDialog.vue?vue&type=style&index=1&id=3490d850&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3490d850",
  null
  
)

export default component.exports